import {createRouter, createWebHistory} from "vue-router";
import Dashboard from "@/views/Dashboard.vue";
import LandingPage from "@/views/LandingPage.vue";
import Integrations from "@/views/Integrations.vue";
import Profile from "@/views/Profile.vue";
import Rtl from "@/views/Rtl.vue";
import SignIn from "@/views/SignIn.vue";
import SignUp from "@/views/SignUp.vue";
import Docs from "@/views/Docs.vue";
import WorkflowBuilder from "@/views/WorkflowBuilder.vue";
import Activity from "@/views/Activity.vue";
import Widgets from "@/views/Widgets.vue";
import ContactUs from "@/views/ContactUs.vue";

const routes = [
    {
        path: "/",
        name: "/",
        component: LandingPage,
        meta: {
            public: true,
        },
    },
    {
        path: "/dashboard",
        name: "Dashboard",
        component: Dashboard,
    },
    {
        path: "/flow-integrations",
        name: "Flow Integrations",
        component: Integrations,
        meta: {
            public: true,
        },

    },
    {
        path: "/workflow",
        name: "DapZap Builder",
        component: WorkflowBuilder,
        meta: {
            public: false,
        },

    },
    {
        path: "/activity",
        name: "Activity",
        component: Activity,
        meta: {
            public: false,
        },

    },
    {
        path: "/docs",
        name: "Docs",
        component: Docs,
        meta: {
            public: true,
        },

    },
    {
        path: "/ui-widgets",
        name: "UI Widgets",
        component: Widgets,
        meta: {
            public: true,
        },

    },
    {
        path: "/profile",
        name: "Profile",
        component: Profile,
    },
    {
        path: "/rtl-page",
        name: "Rtl",
        component: Rtl,
        meta: {
            public: true,
        },
    },
    {
        path: "/sign-in",
        name: "Sign In",
        component: SignIn,
        meta: {
            public: true,
        },
    },
    {
        path: "/sign-up",
        name: "Sign Up",
        component: SignUp,
        meta: {
            public: true,
        },
    },
    {
        path: "/contact-us",
        name: "Contact Us",
        component: ContactUs,
        meta: {
            public: true,
        },
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    linkActiveClass: "active",
});

router.beforeEach((to, from, next) => {
    const user = JSON.parse(localStorage.getItem('user'))
    if (to.matched.some(record => record.meta.public)) {
        next()
    } else if (!user) {
        router.push('/sign-in')
    } else {
        if (to.name === 'logout') {
            router.go('/')
        }
        next()
    }
})

export default router;
